import React from 'react'
import ServiceLayout from '../components/ServiceLayout'
import { useTranslation } from 'react-i18next'

const PublicDataMiningPage = () => {
    const { t } = useTranslation()

    return (
        <ServiceLayout
            breadcrumbs={[
                { label: t('header.home'), path: '/' },
                { label: t('header.service'), path: '/service' },
                { label: t('header.services.bioinformatics.title'), path: '/service/bioinformatics' },
                { label: t('bioinformatics.categories.publicData.title', 'Data Mining & Meta-Analysis') }
            ]}
            title={t('bioinformatics.categories.publicData.title', 'Data Mining & Meta-Analysis')}
        >
            <div className="bio-card-static rounded-xl p-8 border border-primary-200 text-center">
                <span className="material-symbols-outlined text-primary text-4xl mb-4 block">database</span>
                <h2 className="text-xl font-bold text-primary mb-2">{t('bioinformatics.categories.publicData.comingSoon', 'Data Mining & Meta-Analysis coming soon')}</h2>
                <p className="text-text-muted text-sm max-w-lg mx-auto leading-relaxed">
                    {t('bioinformatics.categories.publicData.desc', 'Public datasets, LLM-enabled mining, analytical strategy development.')}
                </p>
            </div>

            <div className="bio-card-tinted rounded-2xl p-6 sm:p-8 border border-primary/20 flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left mt-16">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-white shadow-soft flex items-center justify-center text-primary flex-shrink-0">
                    <span className="material-symbols-outlined text-3xl">contact_support</span>
                </div>
                <div className="flex-1 min-w-0">
                    <h3 className="font-display font-bold text-text-main mb-2 break-words">{t('technicalService.cta.bioinformatics.title')}</h3>
                    <p className="text-sm text-text-muted mb-4 break-words">{t('technicalService.cta.bioinformatics.desc')}</p>
                    <div className="flex flex-wrap gap-3 justify-center sm:justify-start">
                        <a href="/contact" className="btn-primary px-5 py-2 text-xs flex items-center gap-2">{t('technicalService.cta.requestConsultation')} <span className="material-symbols-outlined text-sm">arrow_forward</span></a>
                        <a href="/service-process" className="px-5 py-2 text-xs font-bold text-text-muted hover:text-primary transition-colors flex items-center gap-1.5">{t('technicalService.cta.viewProcess')} <span className="material-symbols-outlined text-sm">arrow_forward</span></a>
                    </div>
                </div>
            </div>
        </ServiceLayout>
    )
}

export default PublicDataMiningPage
